import { Heading } from '@percent/lemonade'
import { ReverificationAgent } from '@percent/cause-dashboard/common/hooks'
import { useTranslation } from 'react-i18next'
import styles from './ReverificationCards.module.scss'

export function ReverificationAgentCard({ agent }: { agent: ReverificationAgent }) {
  const { t } = useTranslation()

  return (
    <section className={styles.section}>
      <Heading level="h2" className={styles.sectionTitle}>
        {t('form.yourDetails')}
      </Heading>
      <div className={styles.card}>
        <span className={styles.primaryText}>{`${agent.firstName} ${agent.lastName}`}</span>
        <span className={styles.secondaryText}>{agent.email}</span>
      </div>
    </section>
  )
}
